import { Box, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import Styles from './NotFound.module.scss';

interface Props {
  backButton?: boolean;
  errorCode?: number;
  heading?: string;
  message?: ReactNode | string;
}

function NotFound({
  errorCode = undefined,
  backButton = false,
  heading = undefined,
  message = 'Page not found',
}: Props): JSX.Element {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Stack
      gap={3}
      margin="3rem 0rem"
      justifyContent="center"
      alignItems="center"
    >
      <Box className={Styles.not_found_svg__container}>
        <svg
          className={Styles.not_found_svg}
          width="150px"
          height="200px"
          viewBox="0 0 837 1045"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none">
            <path
              className={Styles.polygon1}
              stroke={theme.palette.primary.main}
              d="M353,9 L626.664028,170 L626.664028,487 L353,642 L79.3359724,487 L79.3359724,170 L353,9 Z"
            />
            <path
              className={Styles.polygon2}
              stroke={theme.palette.secondary.main}
              d="M78.5,529 L147,569.186414 L147,648.311216 L78.5,687 L10,648.311216 L10,569.186414 L78.5,529 Z"
            />
            <path
              className={Styles.polygon3}
              stroke={theme.palette.primary.main}
              d="M773,186 L827,217.538705 L827,279.636651 L773,310 L719,279.636651 L719,217.538705 L773,186 Z"
            />
            <path
              className={Styles.polygon4}
              stroke={theme.palette.secondary.main}
              d="M639,529 L773,607.846761 L773,763.091627 L639,839 L505,763.091627 L505,607.846761 L639,529 Z"
            />
            <path
              className={Styles.polygon5}
              stroke={theme.palette.primary.main}
              d="M281,801 L383,861.025276 L383,979.21169 L281,1037 L179,979.21169 L179,861.025276 L281,801 Z"
            />
          </g>
        </svg>
      </Box>
      <h1>{errorCode}</h1>
      <h2>{heading}</h2>
      <div className={'text-center'} style={{ marginBottom: '2rem' }}>
        {message}
      </div>
      {backButton && (
        <Button
          className="me-4"
          color="primary"
          variant="contained"
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>
      )}
    </Stack>
  );
}

export default NotFound;
